import React, { useState } from 'react';
import PalletLayoutList from '../../components/PalletLayout/PalletLayoutList';

const PalletLayoutsPage: React.FC = () => {

    return (
        <div className="pallet-layouts-page">
            <PalletLayoutList />
        </div>
    );
};

export default PalletLayoutsPage; 